// Mock data — sourced from gdgoenkasignature.com (original images & text)

export const LOGO_URL = '/logo-gdgss-v4.png?v=4';
export const ORIG = 'https://www.gdgoenkasignature.com/images';

export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Know Us', href: '/know-us.html' },
  {
    label: 'Academics',
    href: '/academics',
    children: [
      { label: 'Montessori Early Years', href: '/montessori.html' },
      { label: 'Real World Curriculum™', href: '/real-world.html' },
      { label: 'Examination', href: '/examination.html' },
    ],
  },
  {
    label: 'Beyond Academics',
    href: '/beyond',
    children: [
      { label: 'Sports', href: '/sports.html' },
      { label: 'Arts', href: '/arts.html' },
    ],
  },
  { label: 'Junior School', href: '/junior-school.html' },
  { label: 'Our Campus', href: '/our-campus.html' },
  { label: 'Boarding', href: '/best-boarding-school-in-india.html' },
  { label: 'Admissions', href: '/admissions.html' },
  { label: 'Gallery', href: '/gallery.html' },
  { label: 'Contact', href: '/contact-us.html' },
];

export const heroSlides = [
  {
    id: 1,
    accent: 'A',
    headline: 'River of Knowledge',
    tagline: 'Day, Weekly & Full Boarding — Gurgaon',
    image: 'https://customer-assets.emergentagent.com/job_goenkasig-new/artifacts/awv4lcd0_455.jpg',
  },
  {
    id: 2,
    accent: 'Champions of',
    headline: 'Tomorrow',
    tagline: 'World-class sports, equestrian and a 60,000 sq.ft. indoor complex',
    image: 'https://customer-assets.emergentagent.com/job_goenkasig-new/artifacts/xx738jfn_915ea07d-cf68-44b2-96c4-a1624a767da6.png',
  },
  {
    id: 4,
    accent: 'A home that',
    headline: 'Grows Leaders',
    tagline: 'Residential life designed to nurture independent, principled young adults',
    image: 'https://customer-assets.emergentagent.com/job_goenkasig-new/artifacts/w1boi2kx_707f856d-9d40-4c45-b02b-81d9c0d56e76.png',
  },
  {
    id: 5,
    accent: 'Where',
    headline: 'Character is Built',
    tagline: 'Kindness, courage and curiosity — the values that stay for life',
    image: 'https://customer-assets.emergentagent.com/job_goenkasig-new/artifacts/bg5ngyqd_74a930fb-8345-4876-93a8-416b29a9389a.png',
  },
];

export const stats = [
  { value: '30+', label: 'Years of Experience' },
  { value: '20', label: 'Acre Sprawling Campus' },
  { value: '60K', label: 'Sq.Ft. Indoor Sports Complex' },
  { value: '60', label: 'Minutes from New Delhi Airport' },
];

export const whyUs = [
  '20 Acre Sprawling Campus',
  '60,000 Sq.Ft. Largest Indoor Sports Complex',
  'Real World Curriculum™ Academics',
  'Cultural Hub — Dedicated Building for Music, Dance & Arts',
  'Technology Lab with Robotics, 3D Printing & Carpentry',
  'Day, Weekly & Full Boarding Options',
];

export const differences = [
  {
    id: 'rwc',
    title: 'Real World',
    subtitle: 'Curriculum™',
    body: 'While books may prove to be stepping stones, the relevant meaningful learning comes from the real world. Our signature Real World Curriculum™ — implemented first in India — turns everyday phenomena into deep, transferable learning.',
  },
  {
    id: 'campus',
    title: 'Signature',
    subtitle: 'Campus',
    body: 'Spread across 20 acres of perfectly designed learning spaces on Sohna Road, Gurgaon. State‑of‑the‑art classrooms, libraries, sports complexes and a dedicated cultural hub — opened in fall 2016.',
  },
  {
    id: 'boarding',
    title: 'Day, Weekly',
    subtitle: '& Full Boarding',
    body: 'Nestled within the campus, our residential life is designed to give students an opportunity to be independent, principled and well‑rounded. Children are nurtured in a safe, hygienic and homely environment.',
  },
  {
    id: 'mentors',
    title: 'Mentors,',
    subtitle: 'not just teachers',
    body: 'Well‑trained mentors deliver excellent results year after year. Our faculty maintains a healthy environment so no student faces emotional, physical or social trauma during studies.',
  },
];

export const pillars = [
  {
    title: 'Montessori Early Years',
    italic: 'a gentle beginning',
    body: 'Personality development, overall growth and exposure to a range of values, attitudes and beliefs — in a carefully prepared environment where curiosity is the first teacher.',
    image: `${ORIG}/banner-montesari.jpg`,
  },
  {
    title: 'Sports',
    italic: 'life skills on the field',
    body: 'Sports is a great way for children to learn essential life skills. From cricket to swimming, equestrian to basketball — the 60,000 sq.ft. indoor complex makes every day an athletic possibility.',
    image: `${ORIG}/banner-sport.jpg`,
  },
  {
    title: 'Arts',
    italic: 'a dedicated cultural hub',
    body: 'An entire building devoted to music, dance, theatre and visual arts — because expression is as essential as equation.',
    image: `${ORIG}/beyond-acedemic-home-th.webp`,
  },
  {
    title: 'Boarding',
    italic: 'a home that grows leaders',
    body: 'Nestled within the sprawling state‑of‑the‑art campus, our residential life offers children an opportunity to grow into independent, principled, well‑rounded young adults.',
    image: `${ORIG}/boarding-home-th.webp`,
  },
];

export const infrastructureTabs = [
  {
    id: 'academic',
    label: 'Academic Facilities',
    image: `${ORIG}/abt-img01.jpg`,
    items: [
      'Smart‑enabled classrooms with collaborative seating',
      'Discovery & innovation labs with robotics and 3D printing',
      'Junior, Middle and Senior libraries',
      'Performing arts studio and music suites',
      'Carpentry & maker studio',
    ],
  },
  {
    id: 'sports',
    label: 'Sports',
    image: `${ORIG}/banner-sport1.jpg`,
    items: [
      '60,000 sq. ft. air‑conditioned indoor sports complex',
      'Olympic‑standard cricket field with practice nets',
      'Heated semi‑Olympic swimming pool',
      'Indoor tennis, badminton, squash and basketball',
      'Equestrian, archery, athletics and yoga',
    ],
  },
  {
    id: 'beyond',
    label: 'Beyond Books',
    image: `${ORIG}/banner-sport2.jpg`,
    items: [
      'Dedicated cultural hub for music, dance and theatre',
      'Visual arts and pottery studios',
      'Public speaking and Model United Nations',
      'Eco‑club, robotics club and entrepreneurship cell',
      'International exchange programmes',
    ],
  },
  {
    id: 'auxiliary',
    label: 'Auxiliary Facilities',
    image: `${ORIG}/abt-img04.jpg`,
    items: [
      'On‑campus medical centre with resident nurse',
      'GPS‑monitored air‑conditioned transport fleet',
      'Multi‑cuisine dining hall with nutritionist menus',
      'CCTV‑enabled secure perimeter and entry',
      'Solar‑powered, rain‑water harvesting campus',
    ],
  },
  {
    id: 'community',
    label: 'Community Outreach',
    image: `${ORIG}/abt-img05.jpg`,
    items: [
      'Sewa Bhav programme — service learning every term',
      'Tie‑ups with local NGOs and government schools',
      'Annual sustainability and tree‑plantation drives',
      'Student‑led councils and leadership initiatives',
      'Parent volunteer guild and alumni mentoring',
    ],
  },
];

export const events = [
  { id: 1, date: 'Nov 25 2023', title: 'Ramayana', body: 'GDGSS illuminated the stage with an awe-inspiring portrayal of the timeless epic.', image: `${ORIG}/events/1.png` },
  { id: 2, date: 'Nov 11 2023', title: 'Diwali', body: 'Radiant moments filled our school as we celebrated Diwali.', image: `${ORIG}/events/3.png` },
  { id: 3, date: 'Nov 02 2023', title: 'Trip to Sariska', body: 'GDGSS organized an exciting two-day trip to Sariska.', image: `${ORIG}/events/02.png` },
  { id: 4, date: 'Oct 31 2023', title: 'Halloween', body: 'Grade 1A and Grade 2B conducted a fantastic Halloween assembly.', image: `${ORIG}/events/4.png` },
  { id: 5, date: 'Oct 19 2023', title: 'Fire Drill', body: 'The successful completion of our scheduled fire drill.', image: `${ORIG}/events/5.png` },
  { id: 6, date: 'Oct 13 2023', title: 'Sewa Bhav', body: 'Bringing "Sewa Bhav" — the spirit of selfless service and compassion.', image: `${ORIG}/events/6.png` },
];

export const gallery = [
  `${ORIG}/activity-th5.jpg`,
  `${ORIG}/activity-th6.jpg`,
  `${ORIG}/activity-th7.jpg`,
  `${ORIG}/activity-th8.jpg`,
  `${ORIG}/activity-th9.jpg`,
  `${ORIG}/activity-th10.jpg`,
  `${ORIG}/activity-th11.jpg`,
  `${ORIG}/thumb/annual-day.jpg`,
];

export const admissionsInfo = {
  open: 'Admissions Open',
  grades: 'Pre‑Nursery to Grade 9 - 12th',
  session: 'Session 2026 — 2027',
  email: 'admissions@gdgss.in',
  phone: '+91 70820 09200',
};

export const contactInfo = {
  address: 'GD Goenka Signature School, Sohna Road, Gurugram, Haryana, India',
  email: 'admissions@gdgss.in',
  phone: '+91 98109 10000',
  altPhone: '+91 70820 09200',
  affiliation: 'CBSE Affiliation No. 531501',
};

export const aboutCopy = {
  eyebrow: 'Know Us',
  heading: 'Best CBSE Board School in',
  italic: 'Gurgaon (Delhi/NCR), India',
  paragraphs: [
    'GD Goenka Signature School is a premium CBSE‑affiliated, day weekly and full boarding school. It is located on a sprawling 20‑acre campus on Sohna Road, Gurgaon — just 60 minutes away from the New Delhi airport.',
    'Parents, visitors and the community claim it to be way ahead of most schools in India, including most international schools. This is largely due to its advanced Real World Curriculum™, the premium infrastructure to support the curriculum and well‑trained mentors who are currently working with students to deliver excellent results.',
    'The school provides a safe and spacious learning environment where students are empowered to nurture their love of learning and thrive on challenges. We cultivate the values of mutual respect, personal responsibility, equality and compassion.',
  ],
  image: 'https://customer-assets.emergentagent.com/job_goenkasig-new/artifacts/zru1r8e7_455.jpg',
};

// ---- Junior School ----
export const juniorSchoolHome = {
  eyebrow: 'Junior School',
  heading: 'Where young minds',
  italic: 'grow with confidence',
  body: 'A nurturing and inspiring learning environment where young minds grow with confidence, creativity, and curiosity. From Pre-Nursery to Class 2, we focus on building a strong academic and emotional foundation through joyful and meaningful learning experiences.',
  meta: 'Designed by Education Design International — a leading American school-design practice.',
  carousel: [
    { src: '/junior/clean/p20.jpg', label: 'Learning Studio — Nursery' },
    { src: '/junior/clean/p22.jpg', label: 'Learning Commons — Nursery' },
    { src: '/junior/clean/p24.jpg', label: 'Story-telling Area' },
    { src: '/junior/clean/p18.jpg', label: 'Amphitheatre' },
    { src: '/junior/clean/p14.jpg', label: 'Discovery Zone' },
    { src: '/junior/clean/p16.jpg', label: 'Lego Lab & Commons' },
  ],
};

export const juniorRooms = [
  {
    id: 'studio',
    title: 'Learning Studio',
    sub: 'Nursery',
    image: '/junior/clean/p20.jpg',
    detail: '/junior/clean/p21.jpg',
    pillars: ['Display wall', 'Teacher\u2019s wall with storage, digital display & writable board', 'Trough sink and reading nook', 'Perforated gypsum ceiling', 'Soft vinyl flooring'],
    body: 'A bright, child-scaled studio designed for focused early-years learning. A teacher\u2019s wall integrates storage, a writable board, digital display and a trough sink — so play, art and discovery flow without interruption.',
  },
  {
    id: 'commons',
    title: 'Learning Commons',
    sub: 'Nursery',
    image: '/junior/clean/p22.jpg',
    detail: '/junior/clean/p23.jpg',
    pillars: ['Writing wall for children', 'Art-gallery wall for student work', 'Wooden baffle ceiling', 'Soft acoustic boards', 'Perforated gypsum ceiling'],
    body: 'A shared community space at the heart of the Nursery cluster — part classroom, part gallery, part reading den. A blackboard wall invites doodles; an art wall celebrates every small triumph.',
  },
  {
    id: 'story',
    title: 'Story-Telling Area',
    sub: 'Second Floor',
    image: '/junior/clean/p24.jpg',
    detail: '/junior/clean/p25.jpg',
    pillars: ['CNC-cut acoustic panelling', 'Bamboo pendant lighting', 'Soft carpet flooring', 'Textured paint walls', 'Tiered seating with ottomans'],
    body: 'A double-height circular space where stories become memories. Warm bamboo pendants, CNC-cut ceiling baffles and a soft circular stage invite children to gather, listen and imagine.',
  },
  {
    id: 'amphi',
    title: 'Amphitheatre',
    sub: 'Drama & Theatrics',
    image: '/junior/clean/p18.jpg',
    detail: '/junior/clean/p19.jpg',
    pillars: ['Wooden coffered beam ceiling', 'Acoustic ceiling panels', 'Printed soft-board acoustic walls', 'Wide stepped wooden seating', 'Performance-grade lighting'],
    body: 'A purpose-built amphitheatre for drama, music and assemblies. Wooden coffered beams overhead, acoustic walls, and broad stepped seating turn every gathering into a stage moment.',
  },
  {
    id: 'discovery',
    title: 'Discovery Zone',
    sub: 'Ground Floor',
    image: '/junior/clean/p14.jpg',
    detail: '/junior/clean/p15.jpg',
    pillars: ['Wooden paneling and finishes', 'Bamboo / cane pendant lights', 'Wooden baffle ceiling', 'Texture-painted gypsum ceiling', 'Vinyl flooring with soft seating'],
    body: 'A welcoming arrival lounge that doubles as an inquiry hub. Natural wood, bamboo lights and cosy nooks invite children to explore, ask and wonder.',
  },
  {
    id: 'lego',
    title: 'Lego Lab & Commons',
    sub: 'Lower Ground Floor',
    image: '/junior/clean/p16.jpg',
    detail: '/junior/clean/p17.jpg',
    pillars: ['Wooden baffle ceiling', 'Acoustic soft-boards', 'Wall activity stations', 'Perforated gypsum ceiling', 'Easy-clean vinyl flooring'],
    body: 'A maker-friendly lab where every child becomes an engineer. Floor-to-ceiling activity walls, soft acoustic boards and abundant table space make building, breaking and rebuilding a daily joy.',
  },
];

// ---- Boarding section ----
export const boardingHome = {
  eyebrow: 'Day, Weekly & Full Boarding',
  heading: 'A home that',
  italic: 'grows leaders.',
  body: 'Nestled within our sprawling state-of-the-art campus, residential life at GD Goenka Signature is designed to give every student the chance to live independently, build lifelong friendships, and grow into a principled, well-rounded young adult — in a safe, warm, hygienic environment that feels like a second home.',
  options: [
    {
      key: 'day',
      title: 'Day Boarding',
      sub: '7:30 am — 6:30 pm',
      desc: 'Extended hours with prep time, evening sport, hobby clubs and a wholesome dinner before the school bus drops your child home.',
      image: `${ORIG}/boarding02.webp`,
    },
    {
      key: 'weekly',
      title: 'Weekly Boarding',
      sub: 'Mon — Fri',
      desc: 'Children stay on campus through the week and head home for weekends — the ideal balance of independence and family time.',
      image: `${ORIG}/boarding03.webp`,
    },
    {
      key: 'full',
      title: 'Full Boarding',
      sub: 'A complete residential experience',
      desc: 'A full residential community with house parents, weekend excursions, traditions and lifelong friendships forged across years.',
      image: `${ORIG}/banner-boarding1.webp`,
    },
  ],
  features: [
    'Spacious twin & quad-share rooms with en-suite bathrooms',
    'Dedicated house parents and 24×7 pastoral care',
    'On-campus medical centre with resident nurse',
    'CCTV-monitored, secure perimeter and entry',
    'Multi-cuisine dining hall with nutritionist menus',
    'Evening prep, sport, hobby clubs and weekend trips',
  ],
  stats: [
    { value: '24×7', label: 'Pastoral Care' },
    { value: '1:8', label: 'House-Parent Ratio' },
    { value: '20', label: 'Acre Secure Campus' },
    { value: '3', label: 'Boarding Options' },
  ],
};

// ---- Academic pages ----
export const montessoriPage = {
  hero: {
    eyebrow: 'Academics · Early Years',
    title: 'Montessori',
    italic: 'Early Years',
    image: `${ORIG}/banner-montesari1.jpg`,
    blurb: 'A child-centric, scientifically grounded approach to learning — where nature and nurture come into harmony, and every child is gently shepherded toward their full potential.',
  },
  blocks: [
    {
      title: 'The Montessori Methodology',
      body: 'The Montessori method is a child-centric educational approach based on scientific observations of children from birth to adulthood, and has been successfully implemented for over a century across cultures. It is a careful blend of developmental milestones (nature) and the prepared environment (nurture). When the two are in harmony, every child\u2019s potential is optimised.',
      image: `${ORIG}/montesori-th1.jpg`,
    },
    {
      title: 'Qualified Montessori Mentors',
      body: 'Under the guidance of qualified Montessori mentors, learners at GD Goenka Signature School begin their journey in the Pre-Primary years. Our classrooms are fully equipped with Montessori material to make learning meaningful — and joyful. A learning triangle is formed by the mentor, the child and the prepared environment.',
      image: `${ORIG}/montesori-th2.jpg`,
    },
    {
      title: 'Practical Life Exercises (PLE)',
      body: 'A holistic approach that develops the child across physical, social, emotional and cognitive domains through Practical Life Exercises — simple activities derived from everyday life that build intellect and concentration. Sensory activities tune and refine the senses; learning happens through direct perception, where abstract concepts come alive in concrete form.',
      image: `${ORIG}/montesori-th3.jpg`,
    },
  ],
  note: 'School strictly implements a \u201cNo Homework Policy\u201d for Classes I and II.',
};

export const realWorldPage = {
  hero: {
    eyebrow: 'Academics',
    title: 'Real World',
    italic: 'Curriculum™',
    image: `${ORIG}/banner-rwc.jpg`,
    blurb: 'While books may prove to be stepping stones, the most meaningful learning comes from the real world. Our signature curriculum educates children inside the context of the world they will inherit.',
  },
  intro:
    'Signature School lays emphasis on building students\u2019 understanding of the world around them, rather than simply passing on information. Classroom learning is structured around relevant contextual issues, with solutions designed through collaboration. Students engage in research and dialogue with peers and mentors as they construct their understanding of the world.',
  pillars: [
    {
      title: 'Academic Knowledge',
      body: 'Contextual knowledge of subjects — Mathematics, Sciences, Humanities and Commerce. Learning standards are designed after studying national and international boards, then contextualised to learners\u2019 needs.',
      image: `${ORIG}/knowledge2.jpg`,
    },
    {
      title: 'River of Knowledge',
      body: 'Our campus is designed around a flowing river called the \u201cRiver of Knowledge\u201d. Naturally-lit, fully equipped classrooms, open-area studios, dedicated Math, Science and ICT labs, and a library of digital + print resources expand each student\u2019s worldview.',
      image: `${ORIG}/river-knowledge1.jpg`,
    },
    {
      title: 'The Real World Approach',
      body: 'Where traditional curricula focus on facts, skills and disciplines, the Real World Curriculum is built on problems, projects and questions. Teachers craft real-life challenges and questions; students solve them and apply learnings to the world they will live in.',
      image: `${ORIG}/real-world-img1.jpg`,
    },
  ],
  skills: [
    { title: 'Communication Skills', body: 'Learners question, share and express ideas openly — ideas are discussed and analysed before reaching a conclusion.' },
    { title: 'Creativity', body: 'Creativity is inherent in all. We give learners the space and tools to explore and nurture their talents.' },
    { title: 'Critical Thinking', body: 'Learners are placed in situations that require them to analyse, evaluate, explain and restructure their thinking, and to build multiple perspectives.' },
    { title: 'Collaboration', body: 'Through projects and group work, students learn interdependence — while concurrently developing as confident, independent learners.' },
    { title: 'World Studies', body: 'A deeper understanding of how our world works, across Economics, Politics, History, Religion, Geography and Culture.' },
    { title: 'Personal Development', body: 'Health & fitness, time management, performing arts and reading habits — the everyday disciplines that shape character.' },
  ],
  outcomes: [
    { title: 'World-Studies Scholars', body: 'Continuously learning new skills to stay abreast of world issues and engage them positively.' },
    { title: 'Emotionally Strong Individuals', body: 'Equipped to face the turbulent challenges of the world with sensitivity and positivity.' },
    { title: 'Creative Global Artisans', body: 'Experiencing visual and performing arts from across the world and honing their own talents.' },
    { title: 'Compelling Visionaries', body: 'Carrying an inspiring picture of a preferred future, and capable of motivating others to pursue it.' },
    { title: 'Effective Communicators', body: 'Able to communicate across cultural, personal and technological differences from any part of the globe.' },
    { title: 'Collaborators', body: 'Skilled at facilitating collaboration and creating synergy across teams, cultures and geographies.' },
  ],
};

export const examinationPage = {
  hero: {
    eyebrow: 'Academics',
    title: 'Examination',
    italic: 'System',
    image: `${ORIG}/examination.jpg`,
    blurb: 'Our school follows the CBSE guidelines from Nursery to Class XI. Students are assessed on the skills they acquire throughout the year — with no exam pressure on the youngest learners.',
  },
  intro:
    'GD Goenka Signature School follows the CBSE-prescribed curriculum across all grades. Assessment is continuous and skill-based, designed to encourage learning rather than create exam anxiety.',
  classes: [
    {
      label: 'Classes I & II',
      tagline: 'no formal assessment',
      body: 'Children are assessed on the basis of day-to-day observation, through general discussion and revision worksheets. The focus stays firmly on joyful learning and skill-building — not marks.',
    },
    {
      label: 'Classes III — V',
      tagline: 'gentle continuous evaluation',
      body: 'Performance is evaluated through unit tests, oral tests and project work — a balanced blend that values process as much as product.',
    },
    {
      label: 'Classes VI — X',
      tagline: 'CBSE pattern, two terms',
      body: 'The academic year is divided into Term I and Term II, each carrying equal weightage. Periodic assessments include unit tests, notebook submissions and subject-enrichment activities. CBSE conducts the Class X board examination for 80 marks per subject (covering 100% of the syllabus), with 20 marks reserved for internal assessment.',
    },
    {
      label: 'Class XI',
      tagline: 'school-based pre-board year',
      body: 'Class XI is structured into Term I and Term II. Each term carries equal weightage. A minimum of 33% in both theory and practical (where applicable) is required for promotion to Class XII. Students failing in one of the five subjects in the annual examination are placed in compartment in that subject.',
    },
  ],
  highlights: [
    'CBSE-aligned curriculum, Nursery to Class XI',
    'Continuous and skill-based evaluation',
    'No formal assessment for Classes I & II',
    'Periodic tests + notebook submissions + enrichment activities',
    'Counselling and remedial support throughout the year',
  ],
};

// Override navLinks to use route paths for academic pages
export const academicLinks = {
  montessori: '/academics/montessori',
  rwc: '/academics/real-world-curriculum',
  exam: '/academics/examination',
  juniorSchool: '/junior-school',
};

// ---- Know Us additional content ----
export const knowUsExtra = {
  aims: [
    { label: 'Balance', body: 'A measured rhythm of academics, sport, the arts and rest \u2014 so children grow whole.' },
    { label: 'Sustain', body: 'Habits, friendships and learning that endure beyond examinations and the school gate.' },
    { label: 'Inspire', body: 'Spaces, stories and mentors that quietly raise every child\u2019s sense of what is possible.' },
  ],
  principles: [
    { title: 'Depth in Leadership', body: 'A broad leadership group \u2014 founder, president, managing director, principal, headmistresses and curriculum coordinators \u2014 guides the school through a fast-changing educational landscape.' },
    { title: 'Best-of-Class Faculty', body: 'Mentors are the heart of GDGSS. A multi-step selection process and continuous development ensure only the finest educators teach our children.' },
    { title: 'Highly-Developed Educational Design', body: 'A coherent, intelligent school-design framework underpins every decision \u2014 from architecture to assessment \u2014 and has been refined since the campus opened in 2016.' },
    { title: 'A Hybrid Learning Experience', body: 'Children move fluidly between traditional classroom learning, small-team project work, and self-directed study supported by purpose-built technology.' },
    { title: 'A Commitment to Independent Study', body: 'Open areas, dedicated time and specially trained mentors give every child the room to pursue their own area of excellence.' },
  ],
  leaders: [
    { name: 'Mr. Rishi Raj Jain', role: 'Founder', body: 'Chairperson of the Radiant Group, with over two million sq.ft. of construction to his name. He conceptualised GDGSS as a place that pairs world-class architecture, laboratories and residential facilities with an enduring set of values.', image: `${ORIG}/rishi-raj.jpg` },
    { name: 'Ms Smita Jain', role: 'President', body: 'Champions a holistic education that nurtures academic, emotional, social and physical growth \u2014 and the values of integrity, empathy and respect that prepare children for a diverse global society.', image: `${ORIG}/smita-maam.jpg` },
    { name: 'Ms Sanya Goenka Jain', role: 'Managing Director', body: 'Leads the school\u2019s commitment to combining innovative teaching, advanced technology and character development \u2014 so every student is well prepared for the demands of the modern world.', image: `${ORIG}/Sanya%20Ma%27am.jpg` },
    { name: 'Dr Alpana Baveja', role: 'Director Principal', body: 'A passionate believer in giving children both \u201croots and wings\u201d \u2014 integrating tradition and modernity, nurturing curiosity, and equipping every child with the life-skills to thrive.', image: `${ORIG}/Alpana%20Ma%27am.jpg` },
    { name: 'Ms Tripti Sharma', role: 'Senior School Headmistress', body: 'With 21+ years in education and qualifications in Mathematics, Economics, English and Education, she leads the senior school with a focus on discovery, lateral thinking and leadership.', image: `${ORIG}/Tripti.jpg` },
    { name: 'Ms Charu Verma', role: 'Primary School Headmistress', body: 'A multi-award-winning educator who oversees Pre-Nursery to Grade IV, known for innovative pedagogy and a deep belief in the educator\u2019s role as a quiet life-shaper.', image: `${ORIG}/charu.jpg` },
  ],
};

// ---- Our Campus additional content ----
export const campusFacilities = [
  { title: 'Resource Centre (Library)', body: 'A spacious world-class library with e-resources, an AV Dome, journals and an extensive collection of literary and reference titles \u2014 each station with internet access.', image: `${ORIG}/libarary-th.jpg` },
  { title: 'Multi-Purpose Hall', body: 'A 1,000-seat auditorium with a large stage and professional light and sound systems \u2014 alongside an amphitheatre and open-air learning spaces for performances.', image: `${ORIG}/multy-purpus-hall-th.jpg` },
  { title: 'Classrooms', body: 'Centrally air-conditioned, with audio-visual aids and modular furniture. A low student-to-teacher ratio gives every child sufficient space and natural light.', image: `${ORIG}/class-room-th1.jpg` },
  { title: 'Infirmary', body: 'Fully equipped with a trained nurse on duty, a doctor on call, an ambulance available 24\u00d77 and a tie-up with Artemis Hospital, Gurgaon.', image: `${ORIG}/infirmary-img.jpg` },
  { title: 'World Caf\u00e9', body: 'A welcoming dining hall with menus drawn up by expert dieticians, organically cultivated produce and separate vegetarian / non-vegetarian preparation areas.', image: `${ORIG}/world-cafe-th.jpg` },
  { title: 'Transportation', body: 'A CNG fleet of deluxe air-conditioned buses with GPS, CCTV, water dispensers, first-aid kits, and trained drivers, conductors and caretakers.', image: `${ORIG}/transport-img.jpg` },
];

export const campusLabs = [
  { title: 'ICT Lab', body: 'Wireless desktops, firewall-protected workstations and WiFi access for projects and research.', image: `${ORIG}/abt-img04.jpg` },
  { title: 'Composite Science Lab', body: 'Stocked with world-class materials, models and equipment, with independent workstations for hands-on absorption.', image: `${ORIG}/abt-img01.jpg` },
  { title: 'Math Lab', body: 'Equipped with Jodogyan and Montessori Math materials \u2014 the latest pedagogical tools to make every concept tangible.', image: `${ORIG}/abt-img04a.jpg` },
  { title: 'Language Labs', body: 'A dedicated space for developing Hindi, English, Spanish and French language skills.', image: `${ORIG}/abt-img001.jpg` },
  { title: 'Real World Curriculum Suite', body: 'A lab built to enhance critical thinking and collaboration \u2014 the home of our signature Real World Curriculum\u2122.', image: `${ORIG}/abt-img05.jpg` },
];

export const campusZones = [
  'Free Play Areas', 'Primary Wing', 'Scholastic Hub', 'Middle School', 'Administrative Wing',
  'Cultural Hub', 'Cafeteria', 'River of Knowledge', 'Football Field', 'Indoor Sports Complex',
  'Outdoor Sports Facilities', 'Senior Wing I', 'Senior Wing II', 'Collaboration Spaces',
  'Hostel Blocks', 'Cricket Field', 'Outdoor Sports',
];

// ---- Admissions extra ----
export const admissionsExtra = {
  intro: 'A holistic approach to overall development \u2014 grooming students as responsible global citizens, ready for the world and ready for the future. Quality international education with global exposure for every child.',
  process: [
    { step: '01', title: 'Submit Enquiry', body: 'Begin online or by calling our admissions desk. Our team responds within one working day.' },
    { step: '02', title: 'Campus Visit', body: 'Walk through the 20-acre campus with our admissions team \u2014 meet mentors and explore facilities.' },
    { step: '03', title: 'Interaction', body: 'A warm, age-appropriate interaction with the child and a brief parent meeting.' },
    { step: '04', title: 'Offer & Onboarding', body: 'Subject to seat availability, an offer is extended and onboarding paperwork begins.' },
  ],
  policy: 'Seats are offered on a first-come, first-serve basis. Where applicants exceed the number of seats for a class, a lottery draw is conducted.',
  hours: 'Monday \u2013 Saturday \u00b7 9:00 am to 3:00 pm',
  brochureUrl: 'https://www.gdgoenkasignature.com/pdfs/Gdgoenkabrochure.pdf',
};
